import processEnv from "../processEnv";

const fetchSeatServices = (offerId: any) => {
  console.log("PASSED QUERY DATA: ", offerId);

  return fetch(`https://api.duffel.com/air/seat_maps?offer_id=${offerId}`, {
    method: "GET",
    referrerPolicy: "no-referrer",
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers":
        "Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers",
      "Content-Type": "application/json",
      "Accept-Encoding": "gzip",
      Accept: "application/json",
      "Access-Control-Allow-Methods": "GET,HEAD,OPTIONS,POST,PUT",
      "Duffel-Version": "v1",
      Authorization:
        "Bearer duffel_test_0D60g6XG_fY4RvLUMRtRQN5MaLzAGG2YnXuIWM9qu2p",
    },
  });
};

export default fetchSeatServices;
